import { mergeProps } from 'react-aria/mergeProps';
import { DOMAttributes } from '@react-types/shared';
import React, { ForwardedRef } from 'react';
import { SapphireStyleProps, useSapphireStyleProps } from '../../utils';

export interface TableHeaderRowProps
  extends Omit<
      DOMAttributes<HTMLTableRowElement>,
      'className' | 'style' | 'dangerouslySetInnerHTML'
    >,
    SapphireStyleProps {
  /**
   * Note: Currently, we don't officially support non-table elements.
   *
   * @default 'tr'
   */
  elementType?: 'tr';
  children?: React.ReactNode;
}

/**
 * Corresponding to `tr` element in native html. Should be rendered inside
 * {@Link Table.Header}
 */

export const TableHeaderRow = React.forwardRef(function TableHeaderRow(
  { children, elementType, ...props }: TableHeaderRowProps,
  ref: ForwardedRef<HTMLTableRowElement>
) {
  const { styleProps, filteredProps } = useSapphireStyleProps(props);
  const ElementType = elementType || 'tr';
  const role = props.role || ElementType === 'tr' ? undefined : 'row';

  return (
    <ElementType
      ref={ref}
      {...mergeProps(filteredProps, { role })}
      className={styleProps.className}
      style={styleProps.style}
    >
      {children}
    </ElementType>
  );
});
